import Layout from '../../views/layouts/index'
const foundRouter = {
  path: '/',
  component: Layout,
  redirect: '/found',
  alwaysShow: true,
  name: 'found',
  children: [
    {
      path: 'found',
      component: () => import('../../views/found/index'),
      name: 'found_index',
    },
    {
      path: 'work/detail',
      component: () => import('../../components/work/detail'),
      name: 'work_detail',
      meta:{activeMenu:'/found'}
    },
    {
      path: 'job/detail',
      component: () => import('../../views/found/position/detail'),
      name: 'job_detail',
      meta:{ activeMenu:'/found' }
    },
    {
      path: 'question/detail',
      component: () => import('../../views/community/detail'),
      name: 'question_detail',
      meta:{ activeMenu:'/found' }
    },
    {
      path: 'question/quiz',
      component: () => import('../../views/community/quiz'),
      name: 'question_quiz',
      meta:{ activeMenu:'/found' }
    },
    {
      path: 'question/my_quiz',
      component: () => import('../../views/community/myDynamic/index'),
      name: 'my_quiz',
      meta:{ activeMenu:'/found' }
    },
  ]
}

export default foundRouter



// WEBPACK FOOTER //
// ./src/router/modules/found.js